// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BfbB","right":"styles_right__-1tSU"};